<template lang="pug">
  //:class="{'toggler--full': !isFullView, 'toggler--collapsed': isFullView}"
  button.toggler.hamburger(
    type="button"
    v-on:click="toggle"
  )
    span.hamburger-box
      span.hamburger-inner
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'Toggler',
  computed: {
    isFullView() {
      return this.$store.state.navigation.fullView;
    }
  },
  methods: {
    ...mapMutations(['collapse', 'expand']),

    toggle() {
      if (this.isFullView) {
        this.collapse();
      } else {
        this.expand();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/core.scss';

.toggler {
  @extend %button-hidden;
  width: $header-height;
  height: $header-height;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.toggler.hamburger {
  display: inline-flex;
}

$hamburger-padding-x: 10px;
$hamburger-padding-y: 0px;
$hamburger-layer-width: 22px;
$hamburger-layer-height: 4px;
$hamburger-layer-spacing: 3px;
$hamburger-layer-color: _palette(base, primary);
$hamburger-layer-border-radius: 1px;
$hamburger-hover-opacity: 0.9;
$hamburger-active-layer-color: $hamburger-layer-color;
$hamburger-active-hover-opacity: $hamburger-hover-opacity;

@import '~hamburgers/_sass/hamburgers/hamburgers';

@media screen and (max-width: 768px) {
  .navbar__nav {
    .hamburger-inner,
    .hamburger-inner::before,
    .hamburger-inner::after {
      // background-color: _palette(borders, light);
      // height: 5px;
      // width: 24px;
      // border-radius: 1px;
    }

    .hamburger-inner::before {
      top: -8px;
    }

    .hamburger-inner::after {
      bottom: -8px;
    }
  }
}
</style>
